export const types: { values: string, label: string }[] = [
  {
    values: 'BUTUN',
    label: 'butun'
  },
  {
    values: 'BOLAK',
    label: "bo'lak"
  }
]